"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

var _bluekeelControllers = require("@bit/bluekeel.controllers.helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var cancelToken = _axios.default.CancelToken;
var source = cancelToken.source();

var buildHitStreetLink = function buildHitStreetLink(payload) {
  return 'https://bkoffers.com/hitstreet/hit_count_hsid2.cfm?' + 'offer_id=' + payload.oid + '&' + 'program_id=' + payload.pid + '&' + 'hsid=' + payload.hsid + '&' + 'eid=' + payload.eid + '&' + 'oid=' + payload.oid + '&' + 'pid=' + payload.pid + '&' + 'sid=' + payload.sid + '&' + 'uid=' + payload.uid;
};

var useHistStreet = function useHistStreet(payload) {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      hsid = _useState2[0],
      setHsid = _useState2[1];

  var pingHitStreet = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var fetchLink, res, backup;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              fetchLink = buildHitStreetLink(payload);
              _context.next = 4;
              return (0, _axios.default)({
                method: 'get',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                url: fetchLink,
                cancelToken: source.token
              });

            case 4:
              res = _context.sent;

              if (!(res.status !== 200)) {
                _context.next = 11;
                break;
              }

              backup = Date.now();
              console.log('Error occured on HitStreet; Fallback ClickID created:', backup);
              (0, _bluekeelControllers.setCookie)('hsid', backup, 3);
              setHsid(backup);
              return _context.abrupt("return");

            case 11:
              ;

              if (!(typeof res.data === 'number')) {
                _context.next = 17;
                break;
              }

              console.log('New HSID fetched:', res.data);
              (0, _bluekeelControllers.setCookie)('hsid', res.data, 3);
              setHsid(res.data);
              return _context.abrupt("return");

            case 17:
              ;
              console.log('HSID passed in URL:', payload.hsid);
              (0, _bluekeelControllers.setCookie)('hsid', payload.hsid, 3);
              setHsid(payload.hsid);
              return _context.abrupt("return");

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](0);

              if (!_axios.default.isCancel(_context.t0)) {
                _context.next = 28;
                break;
              }

              return _context.abrupt("return", {
                status: 'failed',
                message: 'axios hitstreet request cancelled'
              });

            case 28:
              return _context.abrupt("return", {
                status: 'failed',
                message: _context.t0
              });

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 24]]);
    }));

    return function pingHitStreet() {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (!hsid) {
      pingHitStreet();
    }

    ;
    return function () {
      source.cancel('axios request cancelled');
    }; // eslint-disable-next-line
  }, [hsid]);
  return hsid;
};

var _default = useHistStreet;
exports.default = _default;

//# sourceMappingURL=useHitStreet.jsx.map